import { render, staticRenderFns } from "./AccountCancel.vue?vue&type=template&id=490d7895&scoped=true"
import script from "./AccountCancel.vue?vue&type=script&lang=js"
export * from "./AccountCancel.vue?vue&type=script&lang=js"
import style0 from "./AccountCancel.vue?vue&type=style&index=0&id=490d7895&prod&lang=stylus&scoped=true"
import style1 from "./AccountCancel.vue?vue&type=style&index=1&id=490d7895&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490d7895",
  null
  
)

export default component.exports